import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { addStandardTags } from "store/reducers/products/parameters/parameters.actions";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import { ActionButtonConfirmStatus } from "components";
import { ProcessState } from "types/process";

export default function StandardTagsButton() {
  const [processState, setProcessState] = useState<ProcessState>(
    ProcessState.IDLE
  );
  const [statusMessage, setStatusMessage] = useState<string>("");

  const dispatch = useDispatch();

  const resetDialogState = useCallback(() => {
    setProcessState(ProcessState.IDLE);
    setStatusMessage("");
  }, []);

  const handleAddStandardTags = async () => {
    setProcessState(ProcessState.PROCESSING);
    setStatusMessage("Creating Standard Tags");

    dispatch(addStandardTags());

    setProcessState(ProcessState.COMPLETE);
    setStatusMessage("All standard Tags created!");
  };

  return (
    <ActionButtonConfirmStatus
      //Button Props
      variant="outlined"
      color="secondary"
      //Icon props
      icon={BuildCircleIcon}
      iconOnly={false}
      //Tooltip props
      tooltipText="Create any standard tags not already added to this product line"
      tooltipArrow={true}
      tooltipPlacement="right"
      //Dialog Props
      maxWidth="sm"
      fullWidth
      dialogTitle="Create Standard Tags"
      onDialogOpen={resetDialogState}
      disableEscapeKeyDown={true}
      disableCloseOnBackdropClick={true}
      //Content Section Props
      contentSection={
        "Are you sure you want to create all standard Tags? This will also reset the description and category of any existing standard tags to their defaults."
      }
      hideContentOnProcessComplete={true}
      //Action Button Props
      defaultButton="CANCEL"
      cancelButtonText="Cancel"
      okButtonText="OK"
      okButtonWarningColor={false}
      onOKButtonClick={handleAddStandardTags}
      //Status Section Props
      processState={processState}
      statusMessage={statusMessage}
      //Result Section Props
      resultSection={undefined}
    >
      Create Standard Tags
    </ActionButtonConfirmStatus>
  );
}
